import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';

@Entity()
export class CampusLink extends AdornisEntity {
  static override _class = 'CampusLink';

  @Field(() => String)
  link?: Maybe<string>;

  @Field(() => String)
  target?: Maybe<'_blank' | '_self'>;

  get resolvedTarget() {
    return this.target ?? '_self';
  }
}
